/* ═══════════════════════════════════════════════════════════════════════════
   THE PHOTO PACKS — generated by tools/photos.py. Do not edit by hand.

   One pack per trade, shared by every business in it. A business picks one for
   its public page, or uploads its own; see src/images/index.js for how that
   resolves, and the business surface's Website tab for where it is chosen.

   Most entries are photographs, carried over from the v25 prototype. Where a
   trade had too few to offer a real choice, the pack is topped up with
   generated abstract stand-ins, marked `placeholder: true` — those are drawn
   to be unmistakable, because a demo that looks finished gets shipped.

   `alcohol: true` marks a photograph with drink visible. The platform's rule
   under alkoholloven is no alcohol imagery, and these are flagged rather than
   deleted because somebody has to look at them and decide.

   Regenerate with:  npm run photos
   ═══════════════════════════════════════════════════════════════════════ */

export const PACKS = {
  "hair": [
    {
      "id": "hair/firm-klipperiet",
      "file": "hair/firm-klipperiet.webp",
      "shot": "firm-klipperiet",
      "slot": "hero",
      "brief": "Hair & barber — the business at work",
      "placeholder": false
    },
    {
      "id": "hair/firm-lykke",
      "file": "hair/firm-lykke.webp",
      "shot": "firm-lykke",
      "slot": "hero",
      "brief": "Hair & barber — the business at work",
      "placeholder": false
    },
    {
      "id": "hair/firm-northbarber",
      "file": "hair/firm-northbarber.webp",
      "shot": "firm-northbarber",
      "slot": "hero",
      "brief": "Hair & barber — the business at work",
      "placeholder": false
    },
    {
      "id": "hair/firm-stilhus",
      "file": "hair/firm-stilhus.webp",
      "shot": "firm-stilhus",
      "slot": "hero",
      "brief": "Hair & barber — the business at work",
      "placeholder": false
    },
    {
      "id": "hair/hero",
      "file": "hair/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/room",
      "file": "hair/room.webp",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/salon",
      "file": "hair/salon.webp",
      "shot": "salon",
      "slot": "hero",
      "brief": "The salon floor — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/wide",
      "file": "hair/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/barber",
      "file": "hair/barber.webp",
      "shot": "barber",
      "slot": "card",
      "brief": "Barbering in progress — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/hands",
      "file": "hair/hands.webp",
      "shot": "hands",
      "slot": "card",
      "brief": "Hands at work, close — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model",
      "file": "hair/model.webp",
      "shot": "model",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model2",
      "file": "hair/model2.webp",
      "shot": "model2",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model3",
      "file": "hair/model3.webp",
      "shot": "model3",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model4",
      "file": "hair/model4.webp",
      "shot": "model4",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model5",
      "file": "hair/model5.webp",
      "shot": "model5",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/model6",
      "file": "hair/model6.webp",
      "shot": "model6",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/result",
      "file": "hair/result.webp",
      "shot": "result",
      "slot": "card",
      "brief": "The result of the treatment — hair & barber",
      "placeholder": false
    },
    {
      "id": "hair/wash",
      "file": "hair/wash.webp",
      "shot": "wash",
      "slot": "card",
      "brief": "The backwash area — hair & barber",
      "placeholder": false
    }
  ],
  "massage": [
    {
      "id": "massage/firm-harmony",
      "file": "massage/firm-harmony.webp",
      "shot": "firm-harmony",
      "slot": "hero",
      "brief": "Massage & wellbeing — the business at work",
      "placeholder": false
    },
    {
      "id": "massage/firm-muskelverk",
      "file": "massage/firm-muskelverk.webp",
      "shot": "firm-muskelverk",
      "slot": "hero",
      "brief": "Massage & wellbeing — the business at work",
      "placeholder": false
    },
    {
      "id": "massage/firm-nordlys",
      "file": "massage/firm-nordlys.webp",
      "shot": "firm-nordlys",
      "slot": "hero",
      "brief": "Massage & wellbeing — the business at work",
      "placeholder": false
    },
    {
      "id": "massage/firm-roro",
      "file": "massage/firm-roro.webp",
      "shot": "firm-roro",
      "slot": "hero",
      "brief": "Massage & wellbeing — the business at work",
      "placeholder": false
    },
    {
      "id": "massage/hero",
      "file": "massage/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — massage & wellbeing",
      "placeholder": false
    },
    {
      "id": "massage/wide",
      "file": "massage/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — massage & wellbeing",
      "placeholder": false
    },
    {
      "id": "massage/hands",
      "file": "massage/hands.webp",
      "shot": "hands",
      "slot": "card",
      "brief": "Hands at work, close — massage & wellbeing",
      "placeholder": false
    }
  ],
  "childcare": [
    {
      "id": "childcare/hero",
      "file": "childcare/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — childcare & tutoring",
      "placeholder": false
    },
    {
      "id": "childcare/wide",
      "file": "childcare/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — childcare & tutoring",
      "placeholder": false
    },
    {
      "id": "childcare/room",
      "file": "childcare/room.svg",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — childcare & tutoring (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "childcare/detail",
      "file": "childcare/detail.webp",
      "shot": "detail",
      "slot": "card",
      "brief": "A detail of the work, close — childcare & tutoring",
      "placeholder": false
    }
  ],
  "restaurant": [
    {
      "id": "restaurant/dining",
      "file": "restaurant/dining.webp",
      "shot": "dining",
      "slot": "hero",
      "brief": "The dining room during service — restaurant & café",
      "placeholder": false,
      "alcohol": true
    },
    {
      "id": "restaurant/hero",
      "file": "restaurant/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/hero-2",
      "file": "restaurant/hero-2.webp",
      "shot": "hero-2",
      "slot": "hero",
      "brief": "The trade at work, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/hero-3",
      "file": "restaurant/hero-3.webp",
      "shot": "hero-3",
      "slot": "hero",
      "brief": "The trade at work, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/hero-4",
      "file": "restaurant/hero-4.webp",
      "shot": "hero-4",
      "slot": "hero",
      "brief": "The trade at work, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/kitchen",
      "file": "restaurant/kitchen.webp",
      "shot": "kitchen",
      "slot": "hero",
      "brief": "The kitchen and the counter — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/room",
      "file": "restaurant/room.webp",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — restaurant & café",
      "placeholder": false,
      "alcohol": true
    },
    {
      "id": "restaurant/table",
      "file": "restaurant/table.webp",
      "shot": "table",
      "slot": "hero",
      "brief": "A table laid for service — restaurant & café",
      "placeholder": false,
      "alcohol": true
    },
    {
      "id": "restaurant/wide",
      "file": "restaurant/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/wide-2",
      "file": "restaurant/wide-2.webp",
      "shot": "wide-2",
      "slot": "hero",
      "brief": "The premises, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/wide-3",
      "file": "restaurant/wide-3.webp",
      "shot": "wide-3",
      "slot": "hero",
      "brief": "The premises, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/wide-4",
      "file": "restaurant/wide-4.webp",
      "shot": "wide-4",
      "slot": "hero",
      "brief": "The premises, wide — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish",
      "file": "restaurant/dish.webp",
      "shot": "dish",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-00",
      "file": "restaurant/dish-00.webp",
      "shot": "dish-00",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-01",
      "file": "restaurant/dish-01.webp",
      "shot": "dish-01",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-02",
      "file": "restaurant/dish-02.webp",
      "shot": "dish-02",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-03",
      "file": "restaurant/dish-03.webp",
      "shot": "dish-03",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-04",
      "file": "restaurant/dish-04.webp",
      "shot": "dish-04",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-05",
      "file": "restaurant/dish-05.webp",
      "shot": "dish-05",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-06",
      "file": "restaurant/dish-06.webp",
      "shot": "dish-06",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-07",
      "file": "restaurant/dish-07.webp",
      "shot": "dish-07",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-08",
      "file": "restaurant/dish-08.webp",
      "shot": "dish-08",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-09",
      "file": "restaurant/dish-09.webp",
      "shot": "dish-09",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-10",
      "file": "restaurant/dish-10.webp",
      "shot": "dish-10",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-11",
      "file": "restaurant/dish-11.webp",
      "shot": "dish-11",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-12",
      "file": "restaurant/dish-12.webp",
      "shot": "dish-12",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-13",
      "file": "restaurant/dish-13.webp",
      "shot": "dish-13",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-14",
      "file": "restaurant/dish-14.webp",
      "shot": "dish-14",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-15",
      "file": "restaurant/dish-15.webp",
      "shot": "dish-15",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-16",
      "file": "restaurant/dish-16.webp",
      "shot": "dish-16",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-17",
      "file": "restaurant/dish-17.webp",
      "shot": "dish-17",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-18",
      "file": "restaurant/dish-18.webp",
      "shot": "dish-18",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    },
    {
      "id": "restaurant/dish-19",
      "file": "restaurant/dish-19.webp",
      "shot": "dish-19",
      "slot": "card",
      "brief": "A plated dish — restaurant & café",
      "placeholder": false
    }
  ],
  "cleaning": [
    {
      "id": "cleaning/firm-cleanshine",
      "file": "cleaning/firm-cleanshine.webp",
      "shot": "firm-cleanshine",
      "slot": "hero",
      "brief": "Cleaning — the business at work",
      "placeholder": false
    },
    {
      "id": "cleaning/site",
      "file": "cleaning/site.webp",
      "shot": "site",
      "slot": "hero",
      "brief": "A job in progress — cleaning",
      "placeholder": false
    },
    {
      "id": "cleaning/team",
      "file": "cleaning/team.webp",
      "shot": "team",
      "slot": "hero",
      "brief": "The team on site — cleaning",
      "placeholder": false
    },
    {
      "id": "cleaning/room",
      "file": "cleaning/room.svg",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — cleaning (stand-in, not a photograph)",
      "placeholder": true
    }
  ],
  "health": [
    {
      "id": "health/couch",
      "file": "health/couch.webp",
      "shot": "couch",
      "slot": "hero",
      "brief": "The treatment couch — health & medical",
      "placeholder": false
    },
    {
      "id": "health/firm-aktivfys",
      "file": "health/firm-aktivfys.webp",
      "shot": "firm-aktivfys",
      "slot": "hero",
      "brief": "Health & medical — the business at work",
      "placeholder": false
    },
    {
      "id": "health/firm-balansek",
      "file": "health/firm-balansek.webp",
      "shot": "firm-balansek",
      "slot": "hero",
      "brief": "Health & medical — the business at work",
      "placeholder": false
    },
    {
      "id": "health/firm-naerhelse",
      "file": "health/firm-naerhelse.webp",
      "shot": "firm-naerhelse",
      "slot": "hero",
      "brief": "Health & medical — the business at work",
      "placeholder": false
    },
    {
      "id": "health/firm-vita",
      "file": "health/firm-vita.webp",
      "shot": "firm-vita",
      "slot": "hero",
      "brief": "Health & medical — the business at work",
      "placeholder": false
    },
    {
      "id": "health/hero",
      "file": "health/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — health & medical",
      "placeholder": false
    },
    {
      "id": "health/room",
      "file": "health/room.webp",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — health & medical",
      "placeholder": false
    },
    {
      "id": "health/team",
      "file": "health/team.webp",
      "shot": "team",
      "slot": "hero",
      "brief": "The team on site — health & medical",
      "placeholder": false
    },
    {
      "id": "health/wide",
      "file": "health/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — health & medical",
      "placeholder": false
    },
    {
      "id": "health/hands",
      "file": "health/hands.webp",
      "shot": "hands",
      "slot": "card",
      "brief": "Hands at work, close — health & medical",
      "placeholder": false
    },
    {
      "id": "health/staff",
      "file": "health/staff.webp",
      "shot": "staff",
      "slot": "card",
      "brief": "A member of staff at work — health & medical",
      "placeholder": false
    }
  ],
  "legal": [
    {
      "id": "legal/firm-hovden",
      "file": "legal/firm-hovden.webp",
      "shot": "firm-hovden",
      "slot": "hero",
      "brief": "Law & legal — the business at work",
      "placeholder": false
    },
    {
      "id": "legal/firm-nordvik",
      "file": "legal/firm-nordvik.webp",
      "shot": "firm-nordvik",
      "slot": "hero",
      "brief": "Law & legal — the business at work",
      "placeholder": false
    },
    {
      "id": "legal/firm-sandberg",
      "file": "legal/firm-sandberg.webp",
      "shot": "firm-sandberg",
      "slot": "hero",
      "brief": "Law & legal — the business at work",
      "placeholder": false
    },
    {
      "id": "legal/hero",
      "file": "legal/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/office",
      "file": "legal/office.webp",
      "shot": "office",
      "slot": "hero",
      "brief": "The office — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/reception",
      "file": "legal/reception.webp",
      "shot": "reception",
      "slot": "hero",
      "brief": "The reception and waiting area — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/room",
      "file": "legal/room.webp",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/shelf",
      "file": "legal/shelf.webp",
      "shot": "shelf",
      "slot": "hero",
      "brief": "Shelving and stock — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/wide",
      "file": "legal/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/books",
      "file": "legal/books.webp",
      "shot": "books",
      "slot": "card",
      "brief": "The reference shelf — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/desk",
      "file": "legal/desk.webp",
      "shot": "desk",
      "slot": "card",
      "brief": "A desk at work — law & legal",
      "placeholder": false
    },
    {
      "id": "legal/staff",
      "file": "legal/staff.webp",
      "shot": "staff",
      "slot": "card",
      "brief": "A member of staff at work — law & legal",
      "placeholder": false
    }
  ],
  "beauty": [
    {
      "id": "beauty/firm-atelier",
      "file": "beauty/firm-atelier.webp",
      "shot": "firm-atelier",
      "slot": "hero",
      "brief": "Skin, nails & beauty — the business at work",
      "placeholder": false
    },
    {
      "id": "beauty/firm-husetbeauty",
      "file": "beauty/firm-husetbeauty.webp",
      "shot": "firm-husetbeauty",
      "slot": "hero",
      "brief": "Skin, nails & beauty — the business at work",
      "placeholder": false
    },
    {
      "id": "beauty/firm-luxenails",
      "file": "beauty/firm-luxenails.webp",
      "shot": "firm-luxenails",
      "slot": "hero",
      "brief": "Skin, nails & beauty — the business at work",
      "placeholder": false
    },
    {
      "id": "beauty/firm-skinclinic",
      "file": "beauty/firm-skinclinic.webp",
      "shot": "firm-skinclinic",
      "slot": "hero",
      "brief": "Skin, nails & beauty — the business at work",
      "placeholder": false
    },
    {
      "id": "beauty/hero",
      "file": "beauty/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/wide",
      "file": "beauty/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/brow",
      "file": "beauty/brow.webp",
      "shot": "brow",
      "slot": "card",
      "brief": "Brows and lashes, close — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/brow2",
      "file": "beauty/brow2.webp",
      "shot": "brow2",
      "slot": "card",
      "brief": "Brows and lashes, close — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/face",
      "file": "beauty/face.webp",
      "shot": "face",
      "slot": "card",
      "brief": "A finished treatment — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/facial",
      "file": "beauty/facial.webp",
      "shot": "facial",
      "slot": "card",
      "brief": "A facial treatment in progress — skin, nails & beauty",
      "placeholder": false
    },
    {
      "id": "beauty/nails",
      "file": "beauty/nails.webp",
      "shot": "nails",
      "slot": "card",
      "brief": "A finished manicure — skin, nails & beauty",
      "placeholder": false
    }
  ],
  "heating": [
    {
      "id": "heating/hero",
      "file": "heating/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "Ventilation & heating — a warm room on a winter evening",
      "placeholder": false
    },
    {
      "id": "heating/site",
      "file": "heating/site.webp",
      "shot": "site",
      "slot": "any",
      "brief": "Ventilation & heating — fitting the outdoor unit",
      "placeholder": false
    },
    {
      "id": "heating/wide",
      "file": "heating/wide.webp",
      "shot": "wide",
      "slot": "card",
      "brief": "Ventilation & heating — the crew on site",
      "placeholder": false
    },
    {
      "id": "heating/detail",
      "file": "heating/detail.webp",
      "shot": "detail",
      "slot": "card",
      "brief": "Ventilation & heating — the indoor unit in the living room",
      "placeholder": false
    }
  ],
  "home": [
    {
      "id": "home/firm-byggservice",
      "file": "home/firm-byggservice.webp",
      "shot": "firm-byggservice",
      "slot": "hero",
      "brief": "Trades & construction — the business at work",
      "placeholder": false
    },
    {
      "id": "home/firm-nordichome",
      "file": "home/firm-nordichome.webp",
      "shot": "firm-nordichome",
      "slot": "hero",
      "brief": "Trades & construction — the business at work",
      "placeholder": false
    },
    {
      "id": "home/hero",
      "file": "home/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — trades & construction",
      "placeholder": false
    },
    {
      "id": "home/wide",
      "file": "home/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — trades & construction",
      "placeholder": false
    },
    {
      "id": "home/detail",
      "file": "home/detail.webp",
      "shot": "detail",
      "slot": "card",
      "brief": "A detail of the work, close — trades & construction",
      "placeholder": false
    },
    {
      "id": "home/hands",
      "file": "home/hands.webp",
      "shot": "hands",
      "slot": "card",
      "brief": "Hands at work, close — trades & construction",
      "placeholder": false
    }
  ],
  "restoration": [
    {
      "id": "restoration/firm-skadestopp",
      "file": "restoration/firm-skadestopp.webp",
      "shot": "firm-skadestopp",
      "slot": "hero",
      "brief": "Restoration & damage — the business at work",
      "placeholder": false
    },
    {
      "id": "restoration/hero",
      "file": "restoration/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — restoration & damage",
      "placeholder": false
    },
    {
      "id": "restoration/site",
      "file": "restoration/site.webp",
      "shot": "site",
      "slot": "hero",
      "brief": "A job in progress — restoration & damage",
      "placeholder": false
    },
    {
      "id": "restoration/wide",
      "file": "restoration/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — restoration & damage",
      "placeholder": false
    }
  ],
  "accounting": [
    {
      "id": "accounting/firm-bakke",
      "file": "accounting/firm-bakke.webp",
      "shot": "firm-bakke",
      "slot": "hero",
      "brief": "Audit & accounting — the business at work",
      "placeholder": false
    },
    {
      "id": "accounting/room",
      "file": "accounting/room.svg",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — audit & accounting (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "accounting/desk",
      "file": "accounting/desk.webp",
      "shot": "desk",
      "slot": "card",
      "brief": "A desk at work — audit & accounting",
      "placeholder": false
    },
    {
      "id": "accounting/tools",
      "file": "accounting/tools.svg",
      "shot": "tools",
      "slot": "card",
      "brief": "The tools of the trade — audit & accounting (stand-in, not a photograph)",
      "placeholder": true
    }
  ],
  "training": [
    {
      "id": "training/firm-corestudio",
      "file": "training/firm-corestudio.webp",
      "shot": "firm-corestudio",
      "slot": "hero",
      "brief": "Training & fitness — the business at work",
      "placeholder": false
    },
    {
      "id": "training/firm-flytyoga",
      "file": "training/firm-flytyoga.webp",
      "shot": "firm-flytyoga",
      "slot": "hero",
      "brief": "Training & fitness — the business at work",
      "placeholder": false
    },
    {
      "id": "training/firm-styrkelab",
      "file": "training/firm-styrkelab.webp",
      "shot": "firm-styrkelab",
      "slot": "hero",
      "brief": "Training & fitness — the business at work",
      "placeholder": false
    },
    {
      "id": "training/firm-utept",
      "file": "training/firm-utept.webp",
      "shot": "firm-utept",
      "slot": "hero",
      "brief": "Training & fitness — the business at work",
      "placeholder": false
    },
    {
      "id": "training/hero",
      "file": "training/hero.webp",
      "shot": "hero",
      "slot": "hero",
      "brief": "The trade at work, wide — training & fitness",
      "placeholder": false
    },
    {
      "id": "training/wide",
      "file": "training/wide.webp",
      "shot": "wide",
      "slot": "hero",
      "brief": "The premises, wide — training & fitness",
      "placeholder": false
    }
  ],
  "engineer": [
    {
      "id": "engineer/firm-ravn",
      "file": "engineer/firm-ravn.webp",
      "shot": "firm-ravn",
      "slot": "hero",
      "brief": "Engineering & technical — the business at work",
      "placeholder": false
    },
    {
      "id": "engineer/room",
      "file": "engineer/room.svg",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — engineering & technical (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "engineer/desk",
      "file": "engineer/desk.svg",
      "shot": "desk",
      "slot": "card",
      "brief": "A desk at work — engineering & technical (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "engineer/tools",
      "file": "engineer/tools.svg",
      "shot": "tools",
      "slot": "card",
      "brief": "The tools of the trade — engineering & technical (stand-in, not a photograph)",
      "placeholder": true
    }
  ],
  "architect": [
    {
      "id": "architect/firm-vold",
      "file": "architect/firm-vold.webp",
      "shot": "firm-vold",
      "slot": "hero",
      "brief": "Architecture & design — the business at work",
      "placeholder": false
    },
    {
      "id": "architect/room",
      "file": "architect/room.svg",
      "shot": "room",
      "slot": "hero",
      "brief": "The premises, wide, seen from the room — architecture & design (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "architect/desk",
      "file": "architect/desk.svg",
      "shot": "desk",
      "slot": "card",
      "brief": "A desk at work — architecture & design (stand-in, not a photograph)",
      "placeholder": true
    },
    {
      "id": "architect/tools",
      "file": "architect/tools.svg",
      "shot": "tools",
      "slot": "card",
      "brief": "The tools of the trade — architecture & design (stand-in, not a photograph)",
      "placeholder": true
    }
  ]
};

/** Every shot for one trade, heroes first. An empty list is a valid answer:
    the renderer falls back to the typographic hero it drew before there were
    any pictures at all. */
export const pack = code => PACKS[code] || [];

/** One shot by its id, from any pack. */
export const shot = id => Object.values(PACKS).flat().find(s => s.id === id) || null;

/** How many images on the platform are still stand-ins rather than
    photographs. The platform admin shows this, because it is the one number
    that says how finished the public pages actually look. */
export const placeholders = () =>
  Object.values(PACKS).flat().filter(s => s.placeholder).length;

/** Photographs with drink visible. Until somebody decides, the platform can
    find them in one call rather than by looking through every pack. */
export const withAlcohol = () =>
  Object.values(PACKS).flat().filter(s => s.alcohol);
